import { Injectable } from '@angular/core';
import { LocalService } from './storage/local.service';
import { JwtLegFiClaims } from './auth/jwt-legfi-claims.model';
import { LegFiJwtService } from './auth/legfi-jwt.service';

export enum TableTypeNames {
    TRANSACTIONS = 'transactions',
    ISSUED_CHARGES = 'issuedCharges',
    PMC_GROUPS = 'propertyManagementGroups',
    PMC_COMMUNITIES = 'propertyManagementCommunities',
    PMC_FORMS = 'propertyManagementRequestForms',
    PMC_FORM_SUBMISSIONS = 'propertyManagementRequestFormSubmissions',
    PMC_VIOLATIONS = 'propertyManagementViolations',
    PMC_TEAM = 'propertyManagementTeam',
    PMC_FEATURE_FLAGS = 'propertyManagementFeatureFlags',
}

export interface TableColumn {
    key: string;
    title: string;
}

export type StoredTableColumns = {
    [key in TableTypeNames]: string[];
};

@Injectable({
    providedIn: 'root',
})
export class ColumnService
{
    private static get StorageKey() {
        const base = 'payhoa-columns';
        const jwt: JwtLegFiClaims = LegFiJwtService.read();
        return `${base}-${jwt.orgId}`;
    }

    public static read(table: TableTypeNames): string[] {
        const columns =  ColumnService.readAll();

        return columns ? columns[table] : null;
    }

    public static clear(table: TableTypeNames): void {
        const columns =  ColumnService.readAll();

        if (columns && columns[table]) {
            delete columns[table];
        }

        ColumnService.storeAll(columns);
    }

    public static store(table: TableTypeNames, data: TableColumn[]): void {
        let columns =  ColumnService.readAll();

        if (!columns) {
            columns = {} as StoredTableColumns;
        }

        columns[table] = data.map((column) => column.key);

        ColumnService.storeAll(columns);
    }

    private static readAll(): StoredTableColumns {
        const data = LocalService.get(ColumnService.StorageKey);

        return JSON.parse(data) as StoredTableColumns;
    }

    private static clearAll(): void {
        LocalService.destroy(ColumnService.StorageKey);
    }

    private static storeAll(data: StoredTableColumns): void {
        LocalService.set(ColumnService.StorageKey, JSON.stringify(data));
    }
}
